import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { localStorage } from '../misc/storage';
import env from '../misc/env';
var TOKEN_CACHE_KEY = "worklayer::".concat(env.AUTH0_CLIENT_ID, "::").concat(env.AUTH0_AUDIENCE_URL);

/**
 * A cache for managing our authorization token.
 */
var TokenCache = /*#__PURE__*/function () {
  function TokenCache() {
    _classCallCheck(this, TokenCache);
  }
  return _createClass(TokenCache, [{
    key: "save",
    value:
    /**
     * Caches the authentication token.
     *
     * @param {*} loginResult
     */
    function save(loginResult) {
      localStorage.setItem(TOKEN_CACHE_KEY, JSON.stringify({
        access_token: loginResult.accessToken || loginResult.access_token,
        refresh_token: loginResult.refreshToken || loginResult.refresh_token,
        id_token: loginResult.idToken || loginResult.id_token,
        scope: loginResult.scope,
        expires_in: loginResult.expiresIn || loginResult.expires_in,
        token_type: loginResult.tokenType || loginResult.token_type,
        expires_at: Math.floor(Date.now() / 1000) + (loginResult.expiresIn || loginResult.expires_in)
      }));
    }

    /**
     * Retrieves the latest cached token if any.
     *
     * @returns
     */
  }, {
    key: "get",
    value: function get() {
      var token = localStorage.getItem(TOKEN_CACHE_KEY);
      if (!token) {
        return;
      }
      return JSON.parse(token);
    }

    /**
     * Clears the token cache.
     */
  }, {
    key: "clear",
    value: function clear() {
      localStorage.removeItem(TOKEN_CACHE_KEY);
    }
  }]);
}();
export { TokenCache as default };
//# sourceMappingURL=tokenCacheUtil.js.map
